import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { Copy, ClipboardCheck } from './Icons';
import { copyToClipboard } from '../utils';

export default function CopyableField({ label, value, highlight, raw }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copyToClipboard(value, raw);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Box className={`copyable-field${highlight && value ? ' copyable-field--highlight' : ''}`}
      style={highlight && value ? { '--highlight-color': highlight } : undefined}
    >
      <span className="copyable-field__label">{label}</span>
      <span className="copyable-field__value">{value || '-'}</span>
      <IconButton size="small" onClick={handleCopy} className="copyable-field__btn">
        {copied ? <ClipboardCheck size={14} /> : <Copy size={14} />}
      </IconButton>
    </Box>
  );
}
